import { EmoticonTongueOutlineIcon } from './EmoticonTongueOutlineIcon';

/**
 * author: Michael Irigoyen
 * id A08556AE-A0AD-4C7E-9A14-0CD05EE66E03
 * name emoticon-tongue-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-tongue-outline.svg
 * tags
 * - Emoji 
 */
export const FaceTongueOutlineIcon = EmoticonTongueOutlineIcon;
export default FaceTongueOutlineIcon